module.exports = __webpack_public_path__ + "static/img/no2.3bde0a19.png";